<div class="header-wrapper"
     fxLayout="row"
     fxLayout.lt-md="column">

    <div class="title-wrapper"
         fxLayout="row wrap"
         fxLayoutAlign="start center">

        <div class="avatar-wrapper"
             *ngIf="matIco || user || inventory">
            <syn-avatar *ngIf="matIco && !user"
                        [size]="48"
                        [matIco]="matIco">
            </syn-avatar>

            <syn-user-avatar *ngIf="user"
                             [size]="48"
                             [user]="user"
                             backgroundColor="var(--clara-grey--darker)"
                             [clickable]="false">
            </syn-user-avatar>

            <syn-inventory-avatar *ngIf="inventory"
                                  [size]="48"
                                  [inventory]="inventory"
                                  [clickable]="false">
            </syn-inventory-avatar>
        </div>

        <div fxLayout="column" fxLayoutAlign.lt-md="center center">
            <h2 class="title"
                *ngIf="text">{{text}}</h2>
            <small class="caption"
                   *ngIf="caption"
                   [matTooltip]="tooltip">{{caption}}</small>
            <ng-content></ng-content>
        </div>
    </div>

    <div class="action-buttons syn--do-not-print"
         fxLayout="row"
         fxLayoutAlign="end center"
         fxFlexOffset="1em">
        <syn-header-actions-button [actions]="actions" layout="row"></syn-header-actions-button>

        <button *ngIf="menuActions.length" mat-icon-button [matMenuTriggerFor]="actionsMenu">
            <mat-icon svgIcon="dots-vertical"></mat-icon>
        </button>

        <mat-menu #actionsMenu="matMenu" class="syn-action-buttons-menu">
            <syn-header-actions-button [actions]="menuActions" layout="column"></syn-header-actions-button>
        </mat-menu>
    </div>
</div>
